import type { FaireProductEntity } from "../../entity_types/product";

export const p_ztq6ee633c: FaireProductEntity = {
  token: "p_ztq6ee633c",
  type: "product",
  name: "Toddler Personalized Hat Back Home Run Hitter Fine Jersey Tee *Personalize Your Name",
  brandToken: "b_8wgak58597",
  brandName: "Wholesale Accessory Market",
  imageUrl: "https://cdn.faire.com/fastly/61e826980933cec6b5bbbb780234a962296baa30ac396c9f3aac690570b66546.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7dcc95cd15694f0a40c1a0a1f4689412c2c584c30d15042f749c7dd265abcef9.jpeg",
    "https://cdn.faire.com/fastly/08f807f320792e57cf283976d71ff6cea55bd6eba037bd309f54c29cb668e7ed.jpeg",
    "https://cdn.faire.com/fastly/2f44789180186d4dd4b7e69344735281706b89ef1d506f18df429b057c383ae4.jpeg",
    "https://cdn.faire.com/fastly/2bc7f3bb25988e647a2e66952ed34096333056d08245824322c7be1d1919ac06.jpeg",
    "https://cdn.faire.com/fastly/8026df0f87ae060e03345c25ee08f1d079aa04c3435be30b1524e67ceead3e80.jpeg",
    "https://cdn.faire.com/fastly/22433d6ae87aeb7400162dd46938f257a93d3ab3c1f4dc007829011efde3c7d3.png"
  ],
  priceDollars: 10,
  description: "A custom tee made just for them -- because everything's more fun with their name on it.\n\nDesign is done with a soft feel heat transfer.\nTees are made to order and do require 3-4 business days of processing time.\n\n\n * 4.5 oz. 100% Combed Ringspun Cotton Jersey \n * Ash is 99/1 Combed Ringspun Cotton/Polyester \n * Heather is 90/10 Combed Ringspun Cotton/Polyester \n * Bermuda Blackout, Black Leopard, Blended White, Cardinal Blackout, Granite Heather, Ice Blackout, Sangria Blackout, Storm Camo, All Vintage Colors & Wisteria Black are 60/40 Combed Ringspun Cotton/Polyester \n * Topstitch Ribbed Collar \n * Shoulder-to-Shoulder Self-Fabric Back Neck Tape \n * EasyTear Label \n * Double-Needle Sleeves and Bottom Hem \n * CPSIA Compliant Tracking Label in Side Seam ",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:39.503Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
